import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { UsersService } from './service/users.service';
import { enduserInterface } from 'src/app/util/interfaces/enduser';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { concat } from 'rxjs';
import { logInterface, logUserInterface } from 'src/app/util/interfaces/log.interface';
import { faCheckSquare, faSortDown, faSortUp, faSquare, faToggleOff, faToggleOn, faTurkishLira } from '@fortawesome/free-solid-svg-icons';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { permissionI, permissionsInterface } from 'src/app/util/interfaces/customer';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'register-form-users',
	templateUrl: './users.component.html',
	styleUrls: ['./users.component.scss'],
})
export class UsersComponent implements OnInit {
	icons = {
		faCheckSquare: faCheckSquare,
		faSquare: faSquare,
		faSortUp: faSortUp,
		faSortDown: faSortDown,
	};

	labels: LabelsInterface = {
		lbl_geral_sim: 'Yes',
		lbl_geral_nao: 'No',
		lbl_geral_registrar: 'Register',
		lbl_geral_info_analista: 'lbl_geral_info_analista',
		lbl_expandir_para_analista: 'lbl_expandir_para_analista',
		lbl_novos_itens_disponibilizados: '',
		lbl_preencha_todos_asteriscos: '',
		lbl_geral_atualizar: '',
		lbl_preencha_pelo_menos_um_campo_para_continuar: '',
		lbl_geral_buscar: '',
		lbl_buscar_usuarios: '',
		lbl_criar_novo_usuario: '',
		lbl_geral_usuarios_encontrados: '',
		lbl_geral_criado_com_sucesso: '',
		lbl_successful_updated: '',
		lbl_erro_0113: '',
		lbl_registro_de_usuario: '',
		lbl_security_nenhum_registro: '',
		lbl_alterado_por: '',
		lbl_cadastro_permissoes: '',
		lbl_geral_descricao: '',
		lbl_geral_ativo: '',
		lbl_chamado_enduser: '',
		lbl_geral_analista: '',
		lbl_invalid_phone: '',
		lbl_geral_ativar: '',
		lbl_usuario_deve_ser_atribuido_tipo: '',
		lbl_geral_informacoes_gerais: '',
		lbl_geral_usuario: '',
		lbl_voce_ja_possuii_cliente_cadastrado: '',
	};

	searchForm: genericFormInterface[] = [];

	constructor(
		private LabelsService: LabelsService,
		private UsersService: UsersService,
		private NotificationService: NotificationService,
		public ProfileService: ProfileService
	) {
		this.enduserPermissionFilterCallback = this.enduserPermissionFilterCallback.bind(this);
		this.analystPermissionFilterCallback = this.analystPermissionFilterCallback.bind(this);
	}

	isLoadingLabels = true;
	isLoadingRegisterBaseForm = true;
	isLoadingRegisterEnduserForm = true;
	isLoadingRegisterAnalystForm = true;

	isLoadingSearch = false;
	isLoadingUserData = false;
	isRegisteringUser = false;
	isLoadingPermissions = false;
	isLoadingLogs = false;

	view = 'search';

	userList: enduserInterface[] = [];
	userListIAC: iacOptionInterface[] = [];
	selectedUser: enduserInterface = { id: '', fullName: '' };

	selectedTab = 'registerUser';

	registerBaseForm: genericFormInterface[] = [];
	registerEnduserForm: genericFormInterface[] = [];
	registerAnalystForm: genericFormInterface[] = [];
	formDictionary = {};
	analyst_active = false;
	enduser_active = false;

	userPermissionsKeys: string[] = [];
	userPermissions: permissionI = {};
	enduserPermissionSort = {
		filterPermission: '',
		filterDescription: '',
		sortName: 'permission',
		sortOrder: [false, false, false], //start as down, down, down
	};
	analystPermissionSort = {
		filterPermission: '',
		filterDescription: '',
		sortName: 'permission',
		sortOrder: [false, false, false], //start as down, down, down
	};
	userLogs: logUserInterface[] = [];

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.UsersService.getUserSearchForm().subscribe((searchForm) => {
			this.searchForm = [...searchForm];
		});

		this.UsersService.getUserBaseForm().subscribe((registerForm) => {
			this.registerBaseForm = [...registerForm];
			for (const formItem of this.registerBaseForm) {
				this.formDictionary[formItem.name] = formItem;
			}
			this.isLoadingRegisterBaseForm = false;
		});

		this.UsersService.getUserEnduserForm().subscribe((registerForm) => {
			console.log('registerForm', registerForm);
			this.registerEnduserForm = [...registerForm];
			for (const formItem of this.registerEnduserForm) {
				this.formDictionary[formItem.name] = formItem;
			}
			this.formatEnduserFields();
			this.isLoadingRegisterEnduserForm = false;
		});

		this.UsersService.getUserAnalystForm().subscribe((registerForm) => {
			this.registerAnalystForm = [...registerForm];
			for (const formItem of this.registerAnalystForm) {
				this.formDictionary[formItem.name] = formItem;
			}
			this.isLoadingRegisterAnalystForm = false;
		});
	}

	searchUser(): void {
		if (this.isLoadingSearch) return;

		let atLeastOneFieldFulfilled = false;
		for (const formItem of this.searchForm) {
			if (formItem.values[0] != '') atLeastOneFieldFulfilled = true;
			continue;
		}

		if (!atLeastOneFieldFulfilled) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_pelo_menos_um_campo_para_continuar);
			return;
		}

		this.userListIAC = [];
		this.userList = [];
		this.isLoadingSearch = true;
		this.UsersService.getUser(this.searchForm).subscribe((userList) => {
			this.isLoadingSearch = false;
			this.userList = userList;
			for (const user of this.userList) {
				const newUserIAC: iacOptionInterface = {
					name: user.fullName,
					value: user.id,
				};
				this.userListIAC.push({ ...newUserIAC });
			}

			if (this.userListIAC.length === 0 && this.userList.length === 0) {
				this.NotificationService.setNotificationMessage(this.labels.lbl_security_nenhum_registro);
				return;
			}
		});
	}

	getUserData(id: string): void {
		this.isLoadingUserData = true;
		this.UsersService.getUserData(id).subscribe((userData) => {
			this.analyst_active = userData.analyst_active && userData.analyst_active == true ? true : false;
			this.enduser_active = userData.enduser_active && userData.enduser_active == true ? true : false;
			this.selectedUser.id = id;

			for (const baseFormItem of this.registerBaseForm) {
				if (userData[baseFormItem.name]) baseFormItem.values[0] = userData[baseFormItem.name];
			}

			for (const enduserFormItem of this.registerEnduserForm) {
				if (userData[enduserFormItem.name]) enduserFormItem.values[0] = userData[enduserFormItem.name];
			}

			const cdl = this.formDictionary['customer_department_location'];
			if (cdl != undefined) {
				for (let index = 0; index < userData['enduser_customers'].length; index++) {
					const temporary = [];
					temporary.push(
						userData['enduser_customers'][index],
						userData['enduser_departament'][index],
						userData['enduser_location'][index],
						userData['enduser_defaultCustomer'][index]
					);

					cdl.values.push(temporary);
				}
				cdl.outItems = [...cdl.values];
				// cdl.values[0] = userData[cdl.name];
				// cdl.items[0].items.forEach(customerItems => {
				//   if(userData['enduser_customers'].includes(customerItems.values[0])) {
				//     customerItems.hidden = true;
				//   }
				// })
			}

			if (userData['analyst_usertype'] && userData['analyst_usertype'] != '') {
				for (let index = 0; index < this.registerAnalystForm.length; index++) {
					const analystFormItem = this.registerAnalystForm[index];
					if (analystFormItem.inputType === 'multi-select') {
						for (const item of analystFormItem.items) {
							if ((<number[]>userData[analystFormItem.name]).includes(item.values[0])) {
								analystFormItem.values.push(item);
							}
						}
						continue;
					}

					analystFormItem.values[0] = userData[analystFormItem.name];
				}
			}

			this.isLoadingUserData = false;
			this.view = 'register';
		});

		this.isLoadingPermissions = true;
		this.UsersService.getUserPermissions(id).subscribe((permissions) => {
			this.userPermissions = permissions;
			for (const permissionName of Object.keys(this.userPermissions)) {
				this.userPermissionsKeys.push(permissionName);
			}
			this.userPermissionsKeys.sort();
			this.isLoadingPermissions = false;
		});

		this.isLoadingLogs = true;
		this.UsersService.getUserLogs(id).subscribe((logs) => {
			this.userLogs = logs.reverse();
			this.isLoadingLogs = false;
		});
	}

	createUser(): void {
		if (this.isRegisteringUser) return;

		if (this.enduser_active == false && this.analyst_active == false) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_usuario_deve_ser_atribuido_tipo);
			return;
		}

		const concatForm: genericFormInterface[] =
			this.analyst_active == true
				? this.registerBaseForm.concat(this.registerEnduserForm, this.registerAnalystForm)
				: this.registerBaseForm.concat(this.registerEnduserForm);

		if (!this.isFieldsFulfilled(concatForm)) return;

		this.isRegisteringUser = true;
		this.UsersService.postUser(concatForm, this.enduser_active, this.analyst_active).subscribe(
			(res) => {
				this.selectedUser.id = res.MESSAGE;
				this.NotificationService.setNotificationMessage(this.labels.lbl_geral_criado_com_sucesso);
				this.isRegisteringUser = false;
				this.isLoadingLogs = true;
				this.UsersService.getUserLogs(this.selectedUser.id).subscribe((logs) => {
					this.userLogs = logs.reverse();
					this.isLoadingLogs = false;
				});
			},
			(errorRes) => {
				if (errorRes.statusText === 'lbl_ja_existe_um_usuario_este_email') {
					this.NotificationService.setNotificationMessage(this.labels[errorRes.statusText]);
				} else {
					this.NotificationService.setNotificationMessage(this.labels.lbl_erro_0113);
				}
				this.isRegisteringUser = false;
			}
		);
	}

	updateUser(): void {
		if (this.isRegisteringUser) return;

		if (this.enduser_active == false && this.analyst_active == false) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_usuario_deve_ser_atribuido_tipo);
			return;
		}

		const concatForm: genericFormInterface[] =
			this.analyst_active == true
				? this.registerBaseForm.concat(this.registerEnduserForm, this.registerAnalystForm)
				: this.registerBaseForm.concat(this.registerEnduserForm);

		if (!this.isFieldsFulfilled(concatForm)) return;

		this.isRegisteringUser = true;
		this.UsersService.putUser(this.selectedUser.id, concatForm, this.enduser_active, this.analyst_active).subscribe(
			(res) => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
				this.isRegisteringUser = false;
				this.isLoadingLogs = true;
				this.UsersService.getUserLogs(this.selectedUser.id).subscribe((logs) => {
					this.userLogs = logs.reverse();
					this.isLoadingLogs = false;
				});
			},
			(errorRes) => {
				if (errorRes.error.Type === 'lbl_error') {
					this.NotificationService.setNotificationMessage(this.labels[errorRes.error.Message]);
				} else {
					this.NotificationService.setNotificationMessage(this.labels.lbl_erro_0113);
				}
				this.isRegisteringUser = false;
			}
		);
	}

	isFieldsFulfilled(form: genericFormInterface[]): boolean {
		let areFieldsFulfilled = true;

		for (const formItem of form) {
			if (formItem.required && (formItem.values[0] === undefined || formItem.values[0] === '')) {
				areFieldsFulfilled = false;
				formItem.alert = true;
			}
		}

		const analyst_customers: genericFormInterface = this.formDictionary['analyst_customers'];
		analyst_customers.filterItem = [''];

		const analyst_groups: genericFormInterface = this.formDictionary['analyst_groups'];
		analyst_groups.filterItem = [''];

		const phoneNumberRegex = new RegExp(String.raw`^(\+?\d{2,3})?(\d{2,3}|\(\d{2,3}\))?\d?\d{4}-?\d{4}$`);

		const phone: genericFormInterface = this.formDictionary['phone'];
		if (!phoneNumberRegex.test(phone.values[0])) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_invalid_phone);
			phone.alert = true;
			return;
		}

		const cel_phone: genericFormInterface = this.formDictionary['cel_phone'];
		if (!phoneNumberRegex.test(cel_phone.values[0])) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_invalid_phone);
			cel_phone.alert = true;
			return;
		}

		if (!areFieldsFulfilled) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
		}

		return areFieldsFulfilled;
	}

	//Para definir subcampos no customer_department_location;
	formatEnduserFields(): void {
		const cdl: genericFormInterface = this.formDictionary['customer_department_location'];
		cdl.beforeAdd = (e) => {
			const selectedCustomer = cdl.items[0].values[0];
			const editingIndex = cdl.editingIndex;
			cdl.lastEditedItem = cdl.editingIndex;

			const customerList = [];
			for (let index = 0; index < cdl.values.length; index++) {
				customerList.push(cdl.values[index][0]);
			}

			if (
				(editingIndex == undefined && customerList.includes(selectedCustomer)) ||
				(editingIndex != undefined && customerList.includes(selectedCustomer) && customerList[editingIndex] != selectedCustomer)
			) {
				this.NotificationService.setNotificationMessage(this.labels.lbl_voce_ja_possuii_cliente_cadastrado);
				return false;
			}

			return true;
		};
		cdl.afterAdd = () => {
			let lastEditedItem = cdl.lastEditedItem;
			if (lastEditedItem == undefined) lastEditedItem = cdl.values.length - 1;
			//Pegando último item que é o default customer
			if (cdl.values[lastEditedItem].at(-1).toString() == '1') {
				for (const value of cdl.values) {
					value[cdl.values[lastEditedItem].length - 1] = 0;
				}

				cdl.values[lastEditedItem][cdl.values[lastEditedItem].length - 1] = 1;
			}
			cdl.items[1].hidden = true;
			cdl.items[2].hidden = true;
			cdl.items[3].hidden = true;
		};
		// cdl.beforeRemove = (removeIndex: number) => {
		//   for(let i = 0; i < cdl.items[0].items.length; i++) {
		//     let customerItem =  cdl.items[0].items[i];
		//     if(customerItem.values[0] === cdl.values[cdl.values.length-1][0]) {
		//       cdl.items[0].items[i].hidden = false;
		//       break;
		//     }
		//   }
		// }
		// cdl.items.forEach(formItem => {

		// })

		cdl.items[0].extraFunction = (v) => {
			for (let index = 0; index < cdl.items[0].items.length; index++) {
				const item = cdl.items[0].items[index];
				if (item.values[0] != v) continue;
				cdl.isLoading = true;

				this.UsersService.getCustomerDepartment(item.rawValues[0]).subscribe((departments) => {
					cdl.items[1].items = departments;
					cdl.items[1].alert = true;
					cdl.items[1].hidden = false;
				});

				this.UsersService.getCustomerLocations(item.rawValues[0]).subscribe((locations) => {
					cdl.items[2].items = locations;
					cdl.items[2].alert = true;
					cdl.items[2].hidden = false;

					cdl.items[3].hidden = false;
					cdl.isLoading = false;
					this.NotificationService.setNotificationMessage(this.labels.lbl_novos_itens_disponibilizados);
				});
			}
		};
	}

	formatFieldsOnChange() {
		const cel_phone: genericFormInterface = this.formDictionary['cel_phone'];
		const phone: genericFormInterface = this.formDictionary['phone'];

		//cel_phone.values[0] = cel_phone.values[0].replace(/[a-zA-Z]/g, '');
		//phone.values[0] = phone.values[0].replace(/[a-zA-Z]/g, '');

		if (cel_phone.values[0].length > 15) {
			cel_phone.values[0] = cel_phone.values[0].slice(0, 14);
		}

		if (phone.values[0].length > 15) {
			phone.values[0] = phone.values[0].slice(0, 14);
		}
	}

	sortPermissions(userType: 'enduser' | 'analyst'): void {
		//Essa concatenação toda é só pra escrever availableEnduserPermissions ou availableAnalystPermissions
		this['available' + userType.charAt(0).toUpperCase() + userType.slice(1) + 'Permissions'].sort((a, b) => {
			if (this[userType + 'PermissionSort'].sortName === 'permission') {
				if (a.permission > b.permission) {
					return this[userType + 'PermissionSort'].sortOrder[0] ? -1 : 1;
				}
				if (b.permission > a.permission) {
					return this[userType + 'PermissionSort'].sortOrder[0] ? 1 : -1;
				}
				return 0;
			}

			if (this[userType + 'PermissionSort'].sortName === 'description') {
				if (a.description > b.description) {
					return this[userType + 'PermissionSort'].sortOrder[1] ? -1 : 1;
				}
				if (b.description > a.description) {
					return this[userType + 'PermissionSort'].sortOrder[1] ? 1 : -1;
				}
				return 0;
			}

			if (this[userType + 'PermissionSort'].sortName === 'active') {
				if (this[userType + 'Permission'].includes(a.permission) && !this[userType + 'Permission'].includes(b.permission)) {
					return this[userType + 'PermissionSort'].sortOrder[2] ? -1 : 1;
				}

				if (this[userType + 'Permission'].includes(b.permission) && !this[userType + 'Permission'].includes(a.permission)) {
					return this[userType + 'PermissionSort'].sortOrder[2] ? 1 : -1;
				}
				return 0;
			}
		});
	}

	updatePermissions(): void {
		if (this.isRegisteringUser) return;

		this.isRegisteringUser = true;
		this.UsersService.putUserPermissions(this.selectedUser.id, this.userPermissions).subscribe(
			(res) => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
				this.isRegisteringUser = false;
				this.isLoadingLogs = true;
				this.UsersService.getUserLogs(this.selectedUser.id).subscribe((logs) => {
					this.userLogs = logs.reverse();
					this.isLoadingLogs = false;
				});
			},
			() => {
				this.isRegisteringUser = false;
			}
		);
	}

	enduserPermissionFilterCallback(permissionK: string) {
		if (this.enduserPermissionSort.filterPermission.trim() == '' && this.enduserPermissionSort.filterDescription.trim() == '')
			return true;

		if (this.enduserPermissionSort.filterPermission.trim() != '' && this.enduserPermissionSort.filterDescription.trim() != '')
			return (
				permissionK.includes(this.enduserPermissionSort.filterPermission) &&
				this.userPermissions[permissionK].description.includes(this.enduserPermissionSort.filterDescription)
			);
		if (this.enduserPermissionSort.filterPermission.trim() != '')
			return permissionK.includes(this.enduserPermissionSort.filterPermission);
		if (this.enduserPermissionSort.filterDescription.trim() != '')
			return this.userPermissions[permissionK].description.includes(this.enduserPermissionSort.filterDescription);
	}

	analystPermissionFilterCallback(permissionK: string) {
		if (this.analystPermissionSort.filterPermission.trim() == '' && this.analystPermissionSort.filterDescription.trim() == '')
			return true;

		if (this.analystPermissionSort.filterPermission.trim() != '' && this.analystPermissionSort.filterDescription.trim() != '')
			return (
				permissionK.includes(this.analystPermissionSort.filterPermission) &&
				this.userPermissions[permissionK].description.includes(this.analystPermissionSort.filterDescription)
			);
		if (this.analystPermissionSort.filterPermission.trim() != '')
			return permissionK.includes(this.analystPermissionSort.filterPermission);
		if (this.analystPermissionSort.filterDescription.trim() != '')
			return this.userPermissions[permissionK].description.includes(this.analystPermissionSort.filterDescription);
	}
}
